import React from 'react';
import styled from 'styled-components';

interface Props {
  children?: React.ReactNode;
}

const OuterSvg = () => {
  return (
    <svg
      className="outer"
      data-testid="outer-circle"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="23.5" fill="#181D25" stroke="#9AA3B1" />
    </svg>
  );
};
const InnerSvg = () => {
  return (
    <svg
      className="inner"
      data-testid="inner-circle"
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21" cy="21" r="21" fill="#9AA3B1" />
    </svg>
  );
};

const AlphaClusterMarker = ({ children }: Props) => {
  return (
    <Container>
      <OuterSvg />
      <InnerSvg />
      {children}
    </Container>
  );
};

export default AlphaClusterMarker;

const Container = styled.span`
  position: relative;
  .outer {
    z-index: 1;
    fill: var(--Sys-Color-Surface-Neutral-200);
    stroke-width: 1px;
    stroke: var(--Sys-Color-Surface-Neutral-300);
  }
  .inner {
    z-index: 2;
  }
  .dealer-number-alpha {
    z-index: 3;
    color: var(--Sys-Color-Static-900-solid);
  }

  .inner,
  .outer,
  .dealer-number-alpha {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    position: absolute;
  }
`;
